import type { ReactNode } from "react";

import { Header } from "./Header.js";

interface Props {
  children: ReactNode;
  variant?: "home" | "page";
  /** Home only: content rendered full-width below the hero/manifesto grid,
   *  so it stays centred under both columns instead of trailing the text
   *  column on wide screens where the two columns are different heights. */
  actions?: ReactNode;
}

const footer = (
  <footer className="site-footer">
    © 2026 JivaSeva. Content may not be reproduced without permission.
  </footer>
);

export function PageShell({ children, variant = "page", actions }: Props) {
  if (variant === "home") {
    return (
      <div className="page page-home">
        <Header variant="home" />

        {/* On wide screens the hero art and the manifesto sit side by side to
            fill the width; below the breakpoint they stack (image over text).
            Actions render in their own full-width row below the grid so they
            stay centred under both columns regardless of column height. */}
        <main className="content">
          <div className="home-grid">
            <section className="hero-image" aria-hidden="true">
              <img src="/landing.png" alt="" className="hero-image-img" />
            </section>
            <div className="content-inner">{children}</div>
          </div>
          {actions && <div className="home-actions">{actions}</div>}
        </main>

        {footer}
      </div>
    );
  }

  return (
    <div className="page page-page">
      <Header variant="page" />

      <main className="content">
        <div className="content-inner">{children}</div>
      </main>

      {footer}
    </div>
  );
}
